import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import PageSort from '@/components/ui/page-sort/PageSort';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { IBookPage, IBooksPageData } from '@/interfaces/booksPage.interface';

import { getCurrentYear, getCurrentMonth } from '@/helpers/helpers';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { getCurrentPageName } from '@/helpers/helpers';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';

export interface IAudioknigi {
  books: IBookPage;
  sortingName: string;
  sortingUrl?: string | undefined;
}

const Audioknigi: FC<IAudioknigi> = ({ books, sortingName, sortingUrl }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  const currentDate = `${getCurrentMonth().toLowerCase()} ${getCurrentYear()}`;
  const currentPage = books.page;

  //Seo block
  const SEO_TITLE = `Новые аудиокниги в формате mp3, mp4, m4b за ${currentDate} :: слушать или скачать новые аудиокниги${getCurrentPageName(currentPage)}`;
  const SEO_DESCRIPTION = `Новые аудиокниги за ${currentDate} в формате mp3, mp4, m4b  :: BookZ.ru.`;
  const SEO_CANONICAL = '/new_audioknigi';

  return (
    <Layout robotsNoFollow={!!sortingUrl?.length} title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} breadcrumbs={<Breadcrumbs firstPageName="Аудиокниги" />}>
      <SectionTitle name={`Новые аудиокниги :: ${currentDate}`} />
      <PageSort sortingName={sortingName} url="/new_audioknigi/" />
      <div>{books.data && books.data.length ? books.data.map((book: IBooksPageData) => <BookCardItem book={book} key={book.id} />) : <div>Книги не найдены</div>}</div>
      {sortingUrl ? <Pagination pagesCount={pagesCount ?? 0} postName={`new_audioknigi/${sortingUrl}/page=`} /> : <Pagination pagesCount={pagesCount ?? 0} postName="new_audioknigi/page=" />}
    </Layout>
  );
};

export default Audioknigi;
